const initialState = {
    data: [],
  };
  
  const stawkiReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_STAWKI':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default stawkiReducer;